import { Component, Injectable } from '@angular/core';
import { Table } from '../../../shared/components/table/table.component';
import { Button } from '../../../shared/components/button/button.component';
import { RouterModule } from '@angular/router';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { BaseList } from '../../../shared/baseList.component';
import { COMPETENCIAS_COLUMN_NAMES, COMPETENCIAS_FIELDS_CONFIG, COMPETENCIAS_PAGINATE_OPTIONS } from '../../../constants/competencias.constants';
import { CompetenciasService } from '../../../core/competencia.service';
import { CompetenciaInterface } from '../../../models/competencia.model';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-competencias',
  templateUrl: './competencias-list.html',
  imports: [Table, Button, RouterModule, Titledescription],
  styleUrl: './competencias-list.scss'
})
export class CompetenciasList extends BaseList<CompetenciaInterface>{
  entityKey = 'competencias';
  // apiService = new CompetenciasService();
  constructor(public apiService: CompetenciasService) {
    super();
  }
  paginateOptions = COMPETENCIAS_PAGINATE_OPTIONS;
  columnNames = COMPETENCIAS_COLUMN_NAMES;
  fields = COMPETENCIAS_FIELDS_CONFIG;
  override ngOnInit(): void {
  }

}
